import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';
import Header from '../components/Header';
import './InfoPage.css';

const ContactPage = () => {
  const navigate = useNavigate();
  return (
    <div className="info-page">
      <div className="info-header-wrap"><Header /></div>
      <div className="info-container">
        <button className="back-btn" onClick={() => navigate('/')}>← Back</button>
        <h1>Contact Us</h1>
        <p>We're here to help. Reach out for any questions or feedback.</p>
        <p>Email: support@myhelpz.com</p>
        <p>Phone: +91 7003023397</p>
        <p className="muted">Response time: within 24 hours.</p>
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;
